.locate {
	align-self: start;
	display: inline-flex;
	align-items: center;
	gap: var(--space-2);
	padding: var(--space-2) var(--space-3);
	border-radius: 999px;
	border: 1px solid color-mix(in srgb, var(--ink) 12%, transparent);
	background: var(--surface-input);
	color: var(--ink);
	font: inherit;
	font-size: 0.85rem;
	cursor: pointer;
}

.locate:hover {
	border-color: color-mix(in srgb, var(--accent-sage) 50%, transparent);
}

.note {
	margin: 0;
	font-size: 0.8rem;
	color: var(--ink-muted);
}

.retry {
	background: none;
	border: none;
	color: var(--accent-sage);
	font: inherit;
	cursor: pointer;
	padding: 0;
	text-decoration: underline;
}
